export function replaceWithDashes(text: string | null | undefined) {
  if (text) return text.replace(/\s+/g, "-").toLowerCase();
}
